<template>
  <div id="sidebar-menu">
    <ul
      class="sidebar-links custom-scrollbar"
      :class="{ 'sidebar-links--enhanced': shouldUseEnhancedSidebar }"
      id="myDIV"
      :style="[
        layoutClass.split(' ').includes('horizontal-wrapper')
          ? layout.settings.layout_type == 'rtl'
            ? { 'margin-right': margin + 'px' }
            : { 'margin-left': margin + 'px' }
          : { margin: '0px' },
      ]"
    >
      <li class="back-btn">
        <router-link to="/">
          <img class="img-fluid" src="../../assets/images/logo/logo-icon.png" alt=""
        /></router-link>
        <div class="mobile-back text-end">
          <span>Back</span><i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
        </div>
      </li>

      <QuickAccess v-if="shouldUseEnhancedSidebar" :is-internal-user="isInternalUser" />

      <li v-if="homeItem" class="sidebar-list sidebar-home">
        <router-link
          :to="homeItem.path"
          class="sidebar-link sidebar-title"
          :class="{ active: homeItem.active }"
          :title="getTranslation(homeItem.title)"
          @click="
            hidesecondmenu();
            setNavActive(homeItem);
          "
        >
          <svg class="stroke-icon">
            <use :xlink:href="iconSprite + `#${homeItem.icon}`"></use>
          </svg>
          <svg class="fill-icon">
            <use :xlink:href="iconSprite + `#${homeItem.iconf}`"></use>
          </svg>
          <span>
            {{ getTranslation(homeItem.title) }}
          </span>
        </router-link>
      </li>

      <template v-if="shouldUseEnhancedSidebar">
        <template v-for="section in favoriteSections" :key="`favorite-${section.id}`">
          <SectionItem
            variant="accordion"
            :title="getTranslation(section.title)"
            :expanded="isSectionExpanded(section.id)"
            :favorite="true"
            @toggle="toggleSection(section.id)"
            @toggleFavorite="toggleFavoriteSection(section.id)"
            @openArrange="showManageFavoritesModal = true"
          >
            <SectionMenuItems :section="section" />
          </SectionItem>
        </template>

        <template v-for="section in standardSections" :key="section.id">
          <SectionItem
            v-if="section.visibleItems.length > 0"
            variant="accordion"
            :title="getTranslation(section.title)"
            :expanded="isSectionExpanded(section.id)"
            :favorite="false"
            @toggle="toggleSection(section.id)"
            @toggleFavorite="toggleFavoriteSection(section.id)"
            @openArrange="showManageFavoritesModal = true"
          >
            <SectionMenuItems :section="section" />
          </SectionItem>
        </template>
      </template>

      <template v-else>
        <li
          v-for="(menuItem, index) in sectionedMenuItems"
          :key="index"
          v-show="isClassicItemVisible(menuItem, index)"
          class="sidebar-list"
          :class="[
            { 'sidebar-main-title': menuItem.type == 'headtitle' },
            menuItem.showPin ? 'pined' : '',
          ]"
        >
          <div v-if="menuItem.type == 'headtitle'" class="lan-1 sidebar-section-title">
            {{ getTranslation(menuItem.headTitle1) }}
          </div>

          <label :class="'badge badge-' + menuItem.badgeType" v-if="menuItem.badgeType">{{
            getTranslation(menuItem.badgeValue)
          }}</label>
          <a
            href="javascript:void(0)"
            class="sidebar-link sidebar-title"
            :class="{ active: menuItem.active }"
            v-if="menuItem.type == 'sub'"
            :title="getTranslation(menuItem.title)"
            @click="setNavActive(menuItem)"
          >
            <svg class="stroke-icon">
              <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
            </svg>
            <svg class="fill-icon">
              <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
            </svg>
            <span class="lan-3">
              {{ getTranslation(menuItem.title) }}
            </span>
            <div class="according-menu" :class="{ open: menuItem.active }" v-if="menuItem.children">
              <i class="fa fa-angle-right pull-right"></i>
            </div>
          </a>

          <router-link
            :to="menuItem.path"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'link'"
            :class="{ active: menuItem.active }"
            :title="getTranslation(menuItem.title)"
            @click="
              hidesecondmenu();
              setNavActive(menuItem);
            "
          >
            <svg class="stroke-icon">
              <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
            </svg>
            <svg class="fill-icon">
              <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
            </svg>
            <span>
              {{ getTranslation(menuItem.title) }}
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </router-link>

          <a
            :href="menuItem.path"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'extLink'"
            :title="getTranslation(menuItem.title)"
            @click="setNavActive(menuItem)"
          >
            <svg class="stroke-icon">
              <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
            </svg>
            <svg class="fill-icon">
              <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
            </svg>
            <span>
              {{ getTranslation(menuItem.title) }}
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>

          <a
            :href="menuItem.path"
            target="_blank"
            class="sidebar-link sidebar-title"
            v-if="menuItem.type == 'extTabLink'"
            :title="getTranslation(menuItem.title)"
            @click="setNavActive(menuItem)"
          >
            <svg class="stroke-icon">
              <use :xlink:href="iconSprite + `#${menuItem.icon}`"></use>
            </svg>
            <svg class="fill-icon">
              <use :xlink:href="iconSprite + `#${menuItem.iconf}`"></use>
            </svg>
            <span>
              {{ getTranslation(menuItem.title) }}
            </span>
            <i class="fa fa-angle-right pull-right" v-if="menuItem.children"></i>
          </a>

          <ul
            class="sidebar-submenu"
            v-if="menuItem.children"
            :class="{ 'menu-open': menuItem.active }"
            :style="{ display: menuItem.active ? '' : 'none' }"
          >
            <li
              v-for="(childrenItem, childIndex) in menuItem.children"
              v-show="
                hasRequiredRoles(childrenItem) &&
                isInRequiredUserGroup(childrenItem) &&
                isInRequiredPartnerTypes(childrenItem) &&
                isNotExcludedPartner(childrenItem) &&
                hasRequiredFleetApis(childrenItem) &&
                isNotHiddenForInternalUsers(childrenItem) &&
                isNotHiddenForSubFleet(childrenItem) &&
                hasRequiredSubFleet(childrenItem) &&
                hasRequiredRydEmailDomain(childrenItem) &&
                hasRequiredListPrice(childrenItem) &&
                hasRequiredPartnerFeature(childrenItem) &&
                hasRequiredPaidFleetPlanOrFeature(childrenItem) &&
                hasRequiredOnboardingProfile(childrenItem)
              "
              :key="childIndex"
            >
              <a
                class="lan-4 text-truncate"
                :class="{ active: childrenItem.active }"
                href="javascript:void(0)"
                v-if="childrenItem.type == 'sub'"
                @click="setNavActive(childrenItem)"
                :title="getTranslation(childrenItem.title)"
              >
                {{ getTranslation(childrenItem.title) }}
                <label
                  :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                  v-if="childrenItem.badgeType"
                  >{{ childrenItem.badgeValue }}</label
                >
                <i
                  class="fa pull-right mt-1"
                  :class="[childrenItem.active ? 'fa fa-angle-down' : 'fa fa-angle-right']"
                  v-if="childrenItem.children"
                ></i>
              </a>

              <router-link
                class="lan-4 text-truncate"
                :class="{ active: childrenItem.active }"
                :to="childrenItem.path"
                v-if="childrenItem.type == 'link'"
                @click="
                  hidesecondmenu();
                  setNavActive(childrenItem);
                "
                :title="getTranslation(childrenItem.title)"
              >
                {{ getTranslation(childrenItem.title) }}
                <label
                  :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                  v-if="childrenItem.badgeType"
                  >{{ childrenItem.badgeValue }}</label
                >
                <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
              </router-link>

              <a
                :href="childrenItem.path"
                v-if="childrenItem.type == 'extLink'"
                class="submenu-title"
              >
                {{ getTranslation(childrenItem.title) }}
                <label
                  :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                  v-if="childrenItem.badgeType"
                  >{{ childrenItem.badgeValue }}</label
                >
                <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
              </a>

              <a
                class="submenu-title"
                :href="childrenItem.path"
                target="_blank"
                v-if="childrenItem.type == 'extTabLink'"
              >
                {{ getTranslation(childrenItem.title) }}
                <label
                  :class="'badge badge-' + childrenItem.badgeType + ' pull-right'"
                  v-if="childrenItem.badgeType"
                  >{{ childrenItem.badgeValue }}</label
                >
                <i class="fa fa-angle-right pull-right mt-1" v-if="childrenItem.children"></i>
              </a>

              <ul
                class="nav-sub-childmenu submenu-content"
                v-if="childrenItem.children"
                :class="{ opensubchild: childrenItem.active }"
              >
                <li v-for="(childrenSubItem, subIndex) in childrenItem.children" :key="subIndex">
                  <router-link
                    :class="{ active: childrenSubItem.active }"
                    :to="childrenSubItem.path"
                    v-if="childrenSubItem.type == 'link'"
                    @click="
                      hidesecondmenu();
                      setNavActive(childrenSubItem);
                    "
                  >
                    {{ getTranslation(childrenSubItem.title) }}
                    <label
                      :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType"
                      >{{ childrenSubItem.badgeValue }}</label
                    >
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </router-link>

                  <router-link :to="childrenSubItem.path" v-if="childrenSubItem.type == 'extLink'">
                    {{ getTranslation(childrenSubItem.title) }}
                    <label
                      :class="'badge badge-' + childrenSubItem.badgeType + ' pull-right'"
                      v-if="childrenSubItem.badgeType"
                      >{{ childrenSubItem.badgeValue }}</label
                    >
                    <i class="fa fa-angle-right pull-right" v-if="childrenSubItem.children"></i>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </template>
    </ul>

    <!-- Manage Favorites Modal -->
    <PinnedSectionsModal
      :is-open="showManageFavoritesModal"
      :sections="favoriteSections"
      :get-translation="getTranslation"
      @close="showManageFavoritesModal = false"
      @move="({ sectionId, direction }) => moveFavoriteSection(sectionId, direction)"
      @toggle-favorite="toggleFavoriteSection"
    />
  </div>
</template>

<script setup>
import iconSprite from '@/assets/svg/icon-sprite.svg';
import {
  ref,
  computed,
  watch,
  onBeforeMount,
  onMounted,
  onUnmounted,
  nextTick,
  provide,
} from 'vue';
import { useStore } from 'vuex';
import SectionItem from './components/SectionItem.vue';
import SectionMenuItems from './components/SectionMenuItems.vue';
import QuickAccess from './components/QuickAccess.vue';
import PinnedSectionsModal from './components/PinnedSectionsModal.vue';
import { useRoute } from 'vue-router';
import {
  containsPath,
  findMenuItemByPath as findMenuItemByPathShared,
} from '@/constants/menu/menu-path-match';
import { useI18n } from 'vue-i18n';
import { userSettingsService } from '@/services/userSettingsService';
import { layoutClasses } from '../../constants/layout';
import { homeMenuItem } from '@/constants/menu';
import { FLEET_DRIVER_LOGIN_ACCESS_GROUPS } from '../../constants/fleet-driver-login-access-groups';
import { hasPaidFleetSubscriptionPlan } from '@/constants/fleet-subscription-plan-tier';
import { EPricingModel } from '@/constants/sponsor';
import { isSubFleetPartner } from '@/utils/subFleet';
import { passesFleetOnlyPartnerFeature } from '@/utils/fleet-only-partner';
import { getPortalDataEnvironment } from '@/utils/portalEnvironment';

const store = useStore();
const route = useRoute();
const { t } = useI18n();

// ── Reactive state ────────────────────────────────────────────────────────────
const recentItems = ref([]);
const showManageFavoritesModal = ref(false);
const openMenuId = ref(null);
provide('openMenuId', openMenuId);
const preferencesSyncTimeout = ref(null);
const hasAttemptedRemoteNavigationRefresh = ref(false);
const sectionState = ref({
  expandedSections: {},
  utilitySections: { favorites: true, recent: true, favoriteSections: true },
  favoriteSections: [],
  updatedAt: null,
});

// ── Store state ───────────────────────────────────────────────────────────────
const menuItems = computed(() => store.state.menu.data);
// Home is pinned above every sidebar variant, so it never joins a section
const homeItem = computed(() => menuItems.value.find((item) => item.path === homeMenuItem.path));
const sectionedMenuItems = computed(() =>
  menuItems.value.filter((item) => item !== homeItem.value),
);
const layout = computed(() => store.state.layout.layout);
const margin = computed(() => store.state.menu.margin);
const storeWidth = computed(() => store.state.menu.width);

// ── User / auth ───────────────────────────────────────────────────────────────
const currentUserData = computed(() => {
  const str = localStorage.getItem('userAddData');
  return str ? JSON.parse(str) : null;
});
const userRoles = computed(() => currentUserData.value?.roles);
const userGroup = computed(() => currentUserData.value?.userGroup);
const partnerTypes = computed(() => currentUserData.value?.partnerTypes);
const partnerSettings = computed(() => currentUserData.value?.partnerSettings);
const isInternalUser = computed(
  () => (partnerTypes.value || []).includes('RYD_INTERNAL') || userGroup.value === 'ryd',
);
const isFleetPartnerUser = computed(
  () => (partnerTypes.value || []).includes('FLEET_PARTNER') && !isInternalUser.value,
);
const shouldUseEnhancedSidebar = computed(() => !isFleetPartnerUser.value);

// ── Storage keys ──────────────────────────────────────────────────────────────
function resolveUid() {
  return (
    currentUserData.value?.uid ||
    currentUserData.value?.id ||
    currentUserData.value?.email ||
    userGroup.value ||
    'anonymous'
  );
}
const sidebarStateStorageKey = computed(() => `sidebarState:${resolveUid()}`);
const recentItemsStorageKey = computed(() => `sidebarRecent:${resolveUid()}`);
const navigationRefreshStorageKey = computed(() => `sidebarNavigationRefreshed:${resolveUid()}`);

// ── Layout ────────────────────────────────────────────────────────────────────
const layoutClass = computed(
  () =>
    JSON.parse(
      JSON.stringify(
        layoutClasses.find((item) => Object.keys(item).pop() === layout.value.settings.layout),
      ),
    )[layout.value.settings.layout],
);

// ── Section helpers ───────────────────────────────────────────────────────────
function getSectionId(menuItem) {
  if (menuItem.sectionId) return menuItem.sectionId;
  const rawValue = menuItem.headTitle1 || menuItem.headTitle2 || 'section';
  return (
    rawValue
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section'
  );
}

// ── Visibility guards ─────────────────────────────────────────────────────────
function hasRequiredRoles(item) {
  if (!item.requiredRoles || !userRoles.value) return true;
  return item.requiredRoles.some((role) => userRoles.value.includes(role));
}
function isInRequiredUserGroup(item) {
  if (!item.requiredUserGroup) return true;
  return item.requiredUserGroup.includes(userGroup.value);
}
function isInRequiredPartnerTypes(item) {
  if (!item.requiredPartnerTypes) return true;
  return item.requiredPartnerTypes.some((type) => (partnerTypes.value || []).includes(type));
}
function isNotExcludedPartner(item) {
  if (!item.excludedPartners || !userGroup.value) return true;
  return !item.excludedPartners.includes(userGroup.value);
}
function hasRequiredFleetApis(item) {
  if (!item.requiresFleetApis) return true;
  return partnerSettings.value?.useFleetApis === true;
}
function isNotHiddenForFleetApis(item) {
  if (!item.hiddenForFleetApis) return true;
  return partnerSettings.value?.useFleetApis !== true;
}
function isNotHiddenForInternalUsers(item) {
  if (!item.hiddenForInternalUsers) return true;
  return !isInternalUser.value;
}
function isNotHiddenForSubFleet(item) {
  if (!item.hiddenForSubFleet) return true;
  return !isSubFleetPartner(partnerSettings.value);
}
function hasRequiredSubFleet(item) {
  if (!item.requiresSubFleet) return true;
  return isSubFleetPartner(partnerSettings.value);
}
function hasRequiredRydEmailDomain(item) {
  if (!item.requiresRydEmailDomain) return true;
  if (userGroup.value && FLEET_DRIVER_LOGIN_ACCESS_GROUPS.includes(userGroup.value)) return true;
  const domain = partnerSettings.value?.mainSponsor?.partnerProfile?.rydEmailDomain;
  return domain !== null && domain !== undefined && domain !== '';
}
function hasRequiredListPrice(item) {
  if (!item.requiresListPrice) return true;
  return (
    partnerSettings.value?.mainSponsor?.businessContext?.pricingModel === EPricingModel.LIST_PRICE
  );
}
function hasRequiredPartnerFeature(item) {
  if (!item.requiresPartnerFeature) return true;
  if (item.partnerFeatureOpenForInternalUsers && isInternalUser.value) return true;
  return (partnerSettings.value?.featureFlags || {})[item.requiresPartnerFeature] === true;
}
function hasFleetOnlyPartnerFeature(item) {
  return passesFleetOnlyPartnerFeature(
    item,
    partnerTypes.value,
    userGroup.value,
    partnerSettings.value?.featureFlags,
  );
}
function hasRequiredPaidFleetPlanOrFeature(item) {
  const feature = item.requiresPaidFleetPlanOrFeature;
  if (!feature) return true;
  if (hasPaidFleetSubscriptionPlan(partnerSettings.value?.fleetSubscriptionPlanTier)) return true;
  return (partnerSettings.value?.featureFlags || {})[feature] === true;
}
function hasRequiredOnboardingProfile(item) {
  if (!item.requiresOnboardingProfile) return true;
  return !!partnerSettings.value?.onboardingProfile;
}
function isNotHiddenInProduction(item) {
  if (!item.hiddenInProduction) return true;
  // Mirrors the router guard (review finding F-29, R-33): environment-scoped
  // tooling pages stay off the menu when the portal reads production data.
  return getPortalDataEnvironment() !== 'production';
}
function isMenuItemVisible(item) {
  return (
    hasRequiredRoles(item) &&
    isInRequiredUserGroup(item) &&
    isInRequiredPartnerTypes(item) &&
    isNotExcludedPartner(item) &&
    hasRequiredFleetApis(item) &&
    isNotHiddenForFleetApis(item) &&
    isNotHiddenForInternalUsers(item) &&
    isNotHiddenForSubFleet(item) &&
    hasRequiredSubFleet(item) &&
    hasRequiredRydEmailDomain(item) &&
    hasRequiredListPrice(item) &&
    hasRequiredPartnerFeature(item) &&
    hasFleetOnlyPartnerFeature(item) &&
    hasRequiredOnboardingProfile(item) &&
    isNotHiddenInProduction(item) &&
    subMenuHasVisibleChildren(item)
  );
}
function getVisibleChildren(children = []) {
  return children.filter((child) => isMenuItemVisible(child));
}
function subMenuHasVisibleChildren(item) {
  if (!item.children) return true; // not a sub menu — no children to check
  return getVisibleChildren(item.children).length > 0;
}

// ── Classic sidebar (fleet partner users) ────────────────────────────────────
/** The gates the classic sidebar applies to one item (unchanged from the former inline v-show). */
function passesClassicGates(item) {
  return (
    hasRequiredRoles(item) &&
    isInRequiredUserGroup(item) &&
    isInRequiredPartnerTypes(item) &&
    isNotExcludedPartner(item) &&
    hasRequiredFleetApis(item) &&
    isNotHiddenForSubFleet(item) &&
    hasRequiredSubFleet(item) &&
    hasRequiredRydEmailDomain(item) &&
    hasRequiredListPrice(item) &&
    hasRequiredPartnerFeature(item) &&
    hasFleetOnlyPartnerFeature(item) &&
    hasRequiredPaidFleetPlanOrFeature(item) &&
    hasRequiredOnboardingProfile(item) &&
    subMenuHasVisibleChildren(item)
  );
}
/**
 * A section heading is shown only when at least one item below it (up to the next heading) is
 * visible — no empty headings such as "Account Management" for a user without the role its items
 * need. Mirrors the enhanced sidebar, which already drops sections without visible items.
 */
function isClassicItemVisible(item, index) {
  if (!passesClassicGates(item)) return false;
  if (item.type !== 'headtitle') return true;
  const items = sectionedMenuItems.value;
  for (let i = index + 1; i < items.length && items[i].type !== 'headtitle'; i++) {
    if (passesClassicGates(items[i])) return true;
  }
  return false;
}

// ── Grouped sections ──────────────────────────────────────────────────────────
const groupedSections = computed(() => {
  const sections = [];
  let currentSection = null;

  sectionedMenuItems.value.forEach((menuItem) => {
    if (menuItem.type === 'headtitle') {
      currentSection = {
        id: getSectionId(menuItem),
        title: menuItem.headTitle1 || menuItem.headTitle2 || 'Section',
        visibleItems: [],
      };
      sections.push(currentSection);
      return;
    }
    if (!currentSection) {
      currentSection = { id: 'default', title: 'Navigation', visibleItems: [] };
      sections.push(currentSection);
    }
    if (isMenuItemVisible(menuItem)) {
      currentSection.visibleItems.push(menuItem);
    }
  });

  return sections.filter((s) => s.visibleItems.length > 0);
});

const favoriteSections = computed(() =>
  sectionState.value.favoriteSections
    .map((id) => groupedSections.value.find((s) => s.id === id))
    .filter(Boolean),
);
const standardSections = computed(() =>
  groupedSections.value.filter((s) => !isFavoriteSection(s.id)),
);

// ── State normalise / merge ───────────────────────────────────────────────────
function normalizeSidebarState(rawState) {
  return {
    expandedSections: (() => {
      if (!rawState?.expandedSections || typeof rawState.expandedSections !== 'object') return {};
      const entries = Object.entries(rawState.expandedSections);
      let foundOpen = false;
      const result = {};
      for (const [key, val] of entries) {
        if (val === true && !foundOpen) {
          result[key] = true;
          foundOpen = true;
        } else {
          result[key] = false;
        }
      }
      return result;
    })(),
    utilitySections: {
      favorites: rawState?.utilitySections?.favorites !== false,
      recent: rawState?.utilitySections?.recent !== false,
      favoriteSections: rawState?.utilitySections?.favoriteSections !== false,
    },
    favoriteSections: Array.isArray(rawState?.favoriteSections)
      ? rawState.favoriteSections.filter((id) => typeof id === 'string').slice(0, 20)
      : [],
    recentItems: Array.isArray(rawState?.recentItems)
      ? rawState.recentItems
          .filter((item) => item && typeof item === 'object' && typeof item.path === 'string')
          .map((item) => ({
            path: String(item.path),
            title: typeof item.title === 'string' ? item.title : undefined,
            icon: typeof item.icon === 'string' ? item.icon : undefined,
            visitedAt: typeof item.visitedAt === 'string' ? item.visitedAt : undefined,
          }))
          .slice(0, 15)
      : [],
    updatedAt: typeof rawState?.updatedAt === 'string' ? rawState.updatedAt : null,
  };
}

function getSidebarStateTimestampValue(state) {
  const v = state?.updatedAt ? Date.parse(state.updatedAt) : 0;
  return Number.isNaN(v) ? 0 : v;
}
function isIncomingSidebarStateNewer(incoming, current) {
  return getSidebarStateTimestampValue(incoming) > getSidebarStateTimestampValue(current);
}

function mergeSidebarState(localState, remoteState) {
  const local = normalizeSidebarState(localState);
  const remote = normalizeSidebarState(remoteState);
  // expandedSections and utilitySections are always kept local (UI-only state)
  const preferLocal = isIncomingSidebarStateNewer(local, remote);
  return {
    expandedSections: local.expandedSections,
    utilitySections: local.utilitySections,
    favoriteSections: preferLocal ? local.favoriteSections : remote.favoriteSections,
    recentItems: preferLocal ? local.recentItems : remote.recentItems,
    updatedAt: preferLocal ? local.updatedAt : remote.updatedAt,
  };
}

// ── Persistence ───────────────────────────────────────────────────────────────
function storeSidebarStateLocally(state) {
  localStorage.setItem(sidebarStateStorageKey.value, JSON.stringify(normalizeSidebarState(state)));
}
function updateCurrentUserDataNavigationPreferences(state) {
  try {
    const userData = JSON.parse(localStorage.getItem('userAddData') || 'null');
    if (!userData) return;
    userData.navigationPreferences = normalizeSidebarState(state);
    localStorage.setItem('userAddData', JSON.stringify(userData));
  } catch (e) {
    console.warn('Failed to update userAddData navigation preferences', e);
  }
}
function readStoredSidebarState() {
  try {
    return normalizeSidebarState(
      JSON.parse(localStorage.getItem(sidebarStateStorageKey.value) || 'null'),
    );
  } catch (e) {
    console.warn('Failed to load sidebar state', e);
    return normalizeSidebarState(null);
  }
}

function persistSidebarState() {
  sectionState.value = normalizeSidebarState({
    ...sectionState.value,
    updatedAt: new Date().toISOString(),
  });
  storeSidebarStateLocally(sectionState.value);
  updateCurrentUserDataNavigationPreferences(sectionState.value);
}

// ── Section expand / favourite ────────────────────────────────────────────────
function isSectionExpanded(sectionId) {
  return sectionState.value.expandedSections[sectionId] === true;
}
function isFavoriteSection(sectionId) {
  return sectionState.value.favoriteSections.includes(sectionId);
}

function ensureSingleParentExpanded(sectionId) {
  const section = groupedSections.value.find((g) => g.id === sectionId);
  if (!section || section.visibleItems.length !== 1) return;
  const [single] = section.visibleItems;
  if (single?.children?.length) single.active = true;
}

function collapseAllSections() {
  const newExpandedSections = { ...sectionState.value.expandedSections };
  Object.keys(newExpandedSections).forEach((id) => {
    newExpandedSections[id] = false;
  });
  sectionState.value.expandedSections = newExpandedSections;
  persistSidebarState();
}

function ensureSectionExpanded(sectionId) {
  if (!sectionId) return;
  const newExpandedSections = { ...sectionState.value.expandedSections };
  Object.keys(newExpandedSections).forEach((id) => {
    newExpandedSections[id] = false;
  });
  newExpandedSections[sectionId] = true;
  sectionState.value.expandedSections = newExpandedSections;
  ensureSingleParentExpanded(sectionId);
  persistSidebarState();
}

function toggleSection(sectionId) {
  const next = !isSectionExpanded(sectionId);
  const newExpandedSections = { ...sectionState.value.expandedSections };

  if (next) {
    // Close all sections, then open the clicked one
    Object.keys(newExpandedSections).forEach((id) => {
      newExpandedSections[id] = false;
    });
    newExpandedSections[sectionId] = true;
  } else {
    newExpandedSections[sectionId] = false;
  }

  sectionState.value.expandedSections = newExpandedSections;
  if (next) ensureSingleParentExpanded(sectionId);
  persistSidebarState();
}

function toggleFavoriteSection(sectionId) {
  sectionState.value.favoriteSections = isFavoriteSection(sectionId)
    ? sectionState.value.favoriteSections.filter((id) => id !== sectionId)
    : [...sectionState.value.favoriteSections.filter((id) => id !== sectionId), sectionId];
  persistSidebarState();
  scheduleNavigationPreferencesSync();
}

function moveFavoriteSection(sectionId, direction) {
  const sections = [...sectionState.value.favoriteSections];
  const idx = sections.indexOf(sectionId);
  if (direction === 'up' && idx > 0) {
    [sections[idx - 1], sections[idx]] = [sections[idx], sections[idx - 1]];
  } else if (direction === 'down' && idx < sections.length - 1) {
    [sections[idx], sections[idx + 1]] = [sections[idx + 1], sections[idx]];
  }
  sectionState.value.favoriteSections = sections;
  persistSidebarState();
  scheduleNavigationPreferencesSync();
}

// ── Init sidebar state ────────────────────────────────────────────────────────
function initializeSidebarState() {
  const localState = readStoredSidebarState();
  const authState = normalizeSidebarState(currentUserData.value?.navigationPreferences);
  sectionState.value = mergeSidebarState(localState, authState);
  storeSidebarStateLocally(sectionState.value);
  updateCurrentUserDataNavigationPreferences(sectionState.value);
}

// ── Remote preferences ────────────────────────────────────────────────────────
function hasBootstrapNavigationPreferences() {
  return Boolean(currentUserData.value?.navigationPreferences?.updatedAt);
}
function hasLocalNavigationPreferences() {
  return Boolean(sectionState.value?.updatedAt);
}
function markNavigationRefreshCompleted() {
  hasAttemptedRemoteNavigationRefresh.value = true;
  try {
    sessionStorage.setItem(navigationRefreshStorageKey.value, 'true');
  } catch (e) {
    console.warn('Failed to persist navigation refresh flag', e);
  }
}
function hasNavigationRefreshBeenCompleted() {
  if (hasAttemptedRemoteNavigationRefresh.value) return true;
  try {
    return sessionStorage.getItem(navigationRefreshStorageKey.value) === 'true';
  } catch (e) {
    console.warn('Failed to read navigation refresh flag', e);
    return false;
  }
}

function applyRemoteNavigationPreferences(remotePreferences) {
  const remote = normalizeSidebarState(remotePreferences);
  const local = normalizeSidebarState(sectionState.value);
  if (isIncomingSidebarStateNewer(local, remote)) return;
  sectionState.value = mergeSidebarState(sectionState.value, remote);
  recentItems.value = sectionState.value.recentItems || [];
  storeSidebarStateLocally(sectionState.value);
  updateCurrentUserDataNavigationPreferences(sectionState.value);
  localStorage.setItem(recentItemsStorageKey.value, JSON.stringify(recentItems.value.slice(0, 15)));
}

function scheduleNavigationPreferencesSync() {
  if (!shouldUseEnhancedSidebar.value || !currentUserData.value?.uid) return;
  if (preferencesSyncTimeout.value) clearTimeout(preferencesSyncTimeout.value);
  preferencesSyncTimeout.value = setTimeout(syncNavigationPreferences, 600);
}

async function syncNavigationPreferences() {
  if (!shouldUseEnhancedSidebar.value || !currentUserData.value?.uid) return;
  try {
    const saved = await userSettingsService.updateNavigationPreferences({
      favoriteSections: sectionState.value.favoriteSections,
      recentItems: recentItems.value,
    });
    if (saved?.value) {
      applyRemoteNavigationPreferences({ ...saved.value, updatedAt: saved.updatedAt });
    }
  } catch (e) {
    console.warn('Failed to sync navigation preferences', e);
  }
}

async function refreshNavigationPreferencesFromBackend() {
  if (!shouldUseEnhancedSidebar.value || !currentUserData.value?.uid) return;
  if (hasNavigationRefreshBeenCompleted()) return;
  if (hasBootstrapNavigationPreferences() || hasLocalNavigationPreferences()) {
    markNavigationRefreshCompleted();
    return;
  }
  try {
    const remote = await userSettingsService.getNavigationPreferences();
    if (remote?.value) {
      applyRemoteNavigationPreferences({ ...remote.value, updatedAt: remote.updatedAt });
    }
  } catch (e) {
    console.warn('Failed to refresh navigation preferences', e);
  } finally {
    markNavigationRefreshCompleted();
  }
}

// ── Recent items ──────────────────────────────────────────────────────────────
// Path matching (exact path, then `activePathPrefixes`) lives in @/constants/menu/menu-path-match,
// shared with the menu-active coverage guard.
function findMenuItemByPath(items, path) {
  return findMenuItemByPathShared(items, path, isMenuItemVisible);
}
function getAccessibleMenuItemByPath(path) {
  const found = findMenuItemByPath(menuItems.value, path);
  return found && isMenuItemVisible(found) ? found : null;
}

function loadRecentItems() {
  try {
    const stored = JSON.parse(localStorage.getItem(recentItemsStorageKey.value) || '[]');
    if (Array.isArray(stored) && stored.length > 0) {
      recentItems.value = stored.filter((i) => getAccessibleMenuItemByPath(i.path)).slice(0, 15);
      return;
    }
    recentItems.value = (sectionState.value.recentItems || [])
      .filter((i) => getAccessibleMenuItemByPath(i.path))
      .slice(0, 15);
    localStorage.setItem(recentItemsStorageKey.value, JSON.stringify(recentItems.value));
  } catch (e) {
    console.warn('Failed to load recent sidebar items', e);
    recentItems.value = [];
  }
}

function persistRecentItems() {
  localStorage.setItem(recentItemsStorageKey.value, JSON.stringify(recentItems.value.slice(0, 15)));
  sectionState.value = normalizeSidebarState({
    ...sectionState.value,
    recentItems: recentItems.value,
    updatedAt: new Date().toISOString(),
  });
  storeSidebarStateLocally(sectionState.value);
  updateCurrentUserDataNavigationPreferences(sectionState.value);
  scheduleNavigationPreferencesSync();
}

function trackRecentRoute(r) {
  if (!isInternalUser.value || !r?.path) return;
  const item = getAccessibleMenuItemByPath(r.path);
  if (!item || item.type !== 'link') return;
  const entry = {
    path: r.path,
    title: getTranslation(item.title || r.meta?.title || r.name || r.path),
    icon: 'fa-history',
    visitedAt: new Date().toISOString(),
  };
  recentItems.value = [entry, ...recentItems.value.filter((i) => i.path !== entry.path)].slice(
    0,
    15,
  );
  persistRecentItems();
}

// ── Route handling ────────────────────────────────────────────────────────────
function getSectionIdForPath(path) {
  return groupedSections.value.find((g) => g.visibleItems.some((i) => containsPath(i, path)))?.id;
}

function scrollToActiveItem() {
  const sidebarMenu = document.getElementById('sidebar-menu');
  if (!sidebarMenu) return;
  const activeEls = sidebarMenu.querySelectorAll('a.active');
  if (activeEls.length > 0) {
    activeEls[activeEls.length - 1].scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
}

function handleRouteChanged() {
  // Dispatch even without a match so routes outside the sidebar clear the highlight.
  const found = findMenuItemByPath(menuItems.value, route.path);
  store.dispatch('menu/setActiveRoute', found);

  if (shouldUseEnhancedSidebar.value) {
    const sectionId = getSectionIdForPath(route.path);
    // Any page outside the sections (home included) closes whatever was open.
    if (sectionId) ensureSectionExpanded(sectionId);
    else collapseAllSections();
  }
  if (isInternalUser.value) {
    trackRecentRoute(route);
  }
  nextTick(scrollToActiveItem);
  setTimeout(scrollToActiveItem, 350); // Delay execution to allow accordion transitions to complete
}

// ── Nav actions ───────────────────────────────────────────────────────────────
function setNavActive(item) {
  store.dispatch('menu/setNavActive', item);
  if (layoutClass.value.split(' ').includes('compact-sidebar') && window.innerWidth > 991) {
    store.state.menu.activeoverlay = menuItems.value.some((m) => m.active === true);
  }
}

function hidesecondmenu() {
  if (window.innerWidth < 991) {
    store.state.menu.activeoverlay = false;
    if (store.state.menu.togglesidebar) store.dispatch('menu/opensidebar');
    menuItems.value.forEach((m) => {
      m.active = false;
    });
  } else if (layoutClass.value.split(' ').includes('compact-sidebar')) {
    store.state.menu.activeoverlay = false;
    menuItems.value.forEach((m) => {
      m.active = false;
    });
  }
}

// ── Resize / scroll ───────────────────────────────────────────────────────────
function handleResize() {
  store.state.menu.width = window.innerWidth - 450;
}

function handleScroll() {
  if (window.scrollY > 400) {
    const last = layoutClass.value.split(' ').pop();
    if (last === 'material-type' || last === 'advance-layout') {
      const sidebarEl = document.querySelector('.sidebar-main');
      if (sidebarEl) sidebarEl.className = 'sidebar-main hovered';
    }
  } else if (document.getElementById('sidebar-main')) {
    const sidebarEl = document.querySelector('.sidebar-main');
    if (sidebarEl) sidebarEl.className = 'sidebar-main';
  }
}

function handleUnload() {
  const pins = [];
  menuItems.value.forEach((item) => {
    if (item.showPin) pins.push(item.title);
  });
  localStorage.setItem('pins', JSON.stringify(pins));
}

// ── i18n ──────────────────────────────────────────────────────────────────────
function getTranslation(key) {
  if (!key) return '';
  const globalKey = `global.${key}`;
  const result = t(globalKey);
  return result !== globalKey ? result : key;
}

// Shared functions for SectionMenuItems (injected to avoid prop-drilling)
provide('navmenuContext', {
  getTranslation,
  getVisibleChildren,
  setNavActive,
  onLinkClick: hidesecondmenu,
});

// ── Watchers ──────────────────────────────────────────────────────────────────
watch(storeWidth, () => {
  handleResize();
  handleScroll();

  if (window.innerWidth < 992) {
    const newlayout = JSON.parse(
      JSON.stringify(layoutClass.value).replace('horizontal-wrapper', 'compact-wrapper'),
    );
    const pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) pageWrapper.className = 'page-wrapper ' + newlayout;
    store.state.menu.margin = 0;
  } else {
    const pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) pageWrapper.className = 'page-wrapper ' + layoutClass.value;
  }

  if (
    window.innerWidth < 1199 &&
    ['Tokyo', 'Moscow', 'Rome'].includes(layout.value.settings.layout)
  ) {
    menuItems.value.forEach((m) => {
      m.active = false;
    });
  }
});

watch(() => route.path, handleRouteChanged);

// ── Lifecycle ─────────────────────────────────────────────────────────────────
onBeforeMount(() => {
  window.addEventListener('resize', handleResize);
  handleResize();
  if (store.state.menu.width < 991) {
    layout.value.settings.layout = 'Dubai';
    store.state.menu.margin = 0;
  }
  setTimeout(() => {
    const elmnt = document.getElementById('myDIV');
    store.state.menu.menuWidth = elmnt?.offsetWidth;
    if (store.state.menu.menuWidth > window.innerWidth) {
      store.state.menu.hideRightArrow = false;
      store.state.menu.hideLeftArrowRTL = false;
    } else {
      store.state.menu.hideRightArrow = false;
      store.state.menu.hideLeftArrowRTL = true;
    }
  }, 500);
  initializeSidebarState();
  loadRecentItems();
});

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('unload', handleUnload);
  const pins = JSON.parse(localStorage.getItem('pins') || '[]');
  pins.forEach((pin) => {
    const idx = menuItems.value.findIndex((m) => m.title === pin);
    if (idx > -1) menuItems.value[idx].showPin = true;
  });
  handleRouteChanged();
  refreshNavigationPreferencesFromBackend();
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('scroll', handleScroll);
  if (preferencesSyncTimeout.value) clearTimeout(preferencesSyncTimeout.value);
});
</script>

<style scoped>
.sidebar-main-title + .sidebar-main-title {
  margin-top: 4px;
}

/* ── Pinned Home link: top rhythm only in the non-accordion (fleet) sidebar ── */
#sidebar-menu .sidebar-links:not(.sidebar-links--enhanced) > .sidebar-list.sidebar-home {
  margin-top: 6px;
}

/* Keep submenu labels compact and readable in a single line */
#sidebar-menu .sidebar-submenu li > a {
  display: block;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 1.2;
  padding-top: 8px;
  padding-bottom: 8px;
}

#sidebar-menu .sidebar-submenu .text-truncate {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

#sidebar-menu .sidebar-submenu .lan-4,
#sidebar-menu .sidebar-submenu .submenu-title {
  display: block;
  line-height: 1.2;
  height: auto;
  max-height: none;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* ── Enhanced sidebar (internal / API partner): compact spacing ── */
.sidebar-links--enhanced > .sidebar-main-title {
  padding: 4px 10px !important;
  margin-top: 5px !important;
}

.sidebar-links--enhanced > .sidebar-main-title::before {
  display: none !important;
}

/* ── Section content items: card BODY — white, bordered in navy tone ── */
.sidebar-links--enhanced > li.sidebar-section-content {
  position: relative;
  margin-left: 0 !important;
  background: #ffffff !important;
  border-left: 1px solid rgba(46, 52, 130, 0.18) !important;
  border-right: 1px solid rgba(46, 52, 130, 0.18) !important;
  border-top: none !important;
  border-bottom: none !important;
  border-radius: 0 !important;
}

/* ── Last item: close the card bottom ── */
.sidebar-links--enhanced > li.sidebar-section-last-child::before {
  border-radius: 0 0 999px 999px;
}

/* ── Clear gap BEFORE each section header ── */
.sidebar-links--enhanced > .sidebar-main-title:not(.sidebar-favorite-section) {
  margin-top: 12px !important;
}

/* ── STRONG gap + divider after a content group ── */
.sidebar-links--enhanced > li.sidebar-section-last-child + li.sidebar-main-title {
  margin-top: 22px !important;
  padding-top: 0 !important;
}

/* ── Thin divider line before any section header that follows content ── */
.sidebar-links--enhanced > li.sidebar-section-last-child + li.sidebar-main-title::before {
  content: '';
  display: block;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(67, 74, 115, 0.04),
    rgba(67, 74, 115, 0.16),
    rgba(67, 74, 115, 0.04)
  );
  margin: 0 6px 10px;
}

/* ── Visual divider before the standard-section list ── */
.sidebar-links--enhanced li.sidebar-main-title:not(.sidebar-favorite-section):first-of-type {
  margin-top: 16px !important;
  padding-top: 8px !important;
  border-top: 1px solid rgba(67, 74, 115, 0.1) !important;
}

/* ── Tight gap between consecutive closed sections ── */
.sidebar-links--enhanced
  > .sidebar-main-title:not(.sidebar-favorite-section)
  + .sidebar-main-title:not(.sidebar-favorite-section) {
  margin-top: 2px !important;
}

/* ── Section content link items: visually subordinate to section headers ── */
.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title {
  padding: 11px 14px 11px 32px !important;
  min-height: 58px;
  display: flex;
  flex-wrap: nowrap !important;
  align-items: center;
  border-top: 1px solid rgba(67, 74, 115, 0.08);
  position: relative;
  z-index: 1;
}

.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title svg.stroke-icon,
.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title svg.fill-icon {
  width: 18px !important;
  height: 18px !important;
  margin-right: 12px !important;
  flex-shrink: 0;
  color: #69758f;
}

.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title span,
.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title .lan-3 {
  font-size: 13px !important;
  line-height: 1.35 !important;
  font-weight: 700 !important;
  color: #667085 !important;
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap !important;
  display: block !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title .according-menu,
.sidebar-links--enhanced
  > li.sidebar-section-content
  .sidebar-link.sidebar-title
  > .fa-angle-right {
  flex: 0 0 auto;
  margin-left: 10px;
}

.sidebar-links--enhanced > li.sidebar-section-first-child .sidebar-link.sidebar-title {
  border-top: none;
}

.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title:hover {
  background: color-mix(in srgb, var(--theme-default) 4%, white) !important;
}

.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title.active span,
.sidebar-links--enhanced > li.sidebar-section-content .sidebar-link.sidebar-title.active .lan-3 {
  color: #21245e !important;
}

/* ── Submenu items: tighter line-height, truncation ── */
#sidebar-menu .sidebar-submenu li > a,
#sidebar-menu .sidebar-submenu .lan-4,
#sidebar-menu .sidebar-submenu .submenu-title {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  line-height: 1.3 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  position: relative;
  z-index: 1;
}

/* ── Sidebar top-level links: flex row so icon + text never wrap ── */
#sidebar-menu .sidebar-list .sidebar-link.sidebar-title {
  display: flex !important;
  align-items: center;
  flex-wrap: nowrap !important;
  overflow: hidden;
}

/* ── Sidebar link spans: prevent wrapping ── */
#sidebar-menu .sidebar-link span,
#sidebar-menu .sidebar-link .lan-3 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1 1 auto;
}

/* ── Arrow rotation on open submenu ── */
.according-menu i {
  transition: transform 0.3s ease;
}

.according-menu.open i {
  transform: rotate(90deg);
}
</style>
